<div class="spinner-center" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="!loading">
    <h1 mat-dialog-title>{{ (data.validate ? (!data.reject ? 'DEUSTO.DIALOGS.ACCEPT_RENEW_LOAN.TITLE' :
        'DEUSTO.DIALOGS.REJECT_RENEW_LOAN.TITLE') : 'DEUSTO.DIALOGS.RENEW_LOAN.TITLE') | translate }}</h1>
    <mat-dialog-content>
        <span [innerHTML]="sanitizedHtmlContent()">
        </span>
        <form class="mt15" [formGroup]="formGroup">
            <div class="div-wrap">
                <smt-date-input [group]="formGroup" [controlName]="'returnDate'"
                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RETURN_DATE'" [dateType]="DateType.DATE"></smt-date-input>

                <div [ngClass]="data.reject ? 'div-wrap w100' : 'div-wrap w45'"
                    *ngIf="formGroup.get('oldRenewDate').value">
                    <h3 class="mt5">Solicitud</h3>
                    <smt-date-input *ngIf="formGroup.get('oldRenewDate').value" [group]="formGroup"
                        [controlName]="'oldRenewDate'"
                        [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RENEW_DATE'" [dateType]="DateType.DATE"></smt-date-input>

                    <mat-form-field class="w100">
                        <mat-label>
                            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RENEW_OBSERVATIONS' | translate
                            }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="oldRenewObservations"></textarea>
                    </mat-form-field>
                </div>

                <div *ngIf="!data.reject"
                    [ngClass]="formGroup.get('oldRenewDate').value ? 'div-wrap w45' : 'div-wrap w100'">
                    <h3 class="mt5"> {{ data.validate ? 'Resolución' : 'Nueva Solicitud' }}</h3>
                    <smt-date-input *ngIf="!data.validate" [group]="formGroup" [controlName]="'renewDate'"
                        [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RENEW_DATE'" [minDate]="minDate" [dateType]="DateType.DATE"></smt-date-input>

                    <smt-date-input *ngIf="data.validate" [group]="formGroup" [controlName]="'finalReturnDate'"
                        [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RETURN_DATE'"
                        [minDate]="minDate" [dateType]="DateType.DATE"></smt-date-input>

                    <mat-form-field class="w100">
                        <mat-label>
                            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RENEW_OBSERVATIONS' | translate
                            }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="renewObservations"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button color="accent" [mat-dialog-close]="false" cdkFocusInitial>{{
            (data.validate ? (!data.reject ? 'DEUSTO.DIALOGS.ACCEPT_RENEW_LOAN.NO_LABEL' :
            'DEUSTO.DIALOGS.REJECT_RENEW_LOAN.NO_LABEL') : 'DEUSTO.DIALOGS.RENEW_LOAN.NO_LABEL') | translate }}</button>
        <button mat-raised-button color="primary" (click)="renewLoan()" [disabled]="formGroup.invalid">{{(data.validate
            ? (!data.reject ? 'DEUSTO.DIALOGS.ACCEPT_RENEW_LOAN.YES_LABEL' : 'DEUSTO.DIALOGS.REJECT_RENEW_LOAN.YES_LABEL')
            : 'DEUSTO.DIALOGS.RENEW_LOAN.YES_LABEL') | translate }}</button>
    </mat-dialog-actions>
</ng-container>